(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[428],{

/***/ 6903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _Users_kayce_thomas_devops_src_custodiabank_engineering_custodia_mono_claude_worktrees_sc_41628_static_site_deploy_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _components_molecules_Seo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1424);
/* harmony import */ var _components_screens_funnels_custody_whitepaper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8382);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9597);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_Users_kayce_thomas_devops_src_custodiabank_engineering_custodia_mono_claude_worktrees_sc_41628_static_site_deploy_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var Page = function Page(props) {
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.Fragment, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_molecules_Seo__WEBPACK_IMPORTED_MODULE_2__/* .Seo */ .p, {
      title: "Custody Whitepaper | ".concat(_config__WEBPACK_IMPORTED_MODULE_4__/* .site.title */ .l.title),
      image: {
        url: "".concat(_config__WEBPACK_IMPORTED_MODULE_4__/* .site.host */ .l.host, "/images/funnel/custody/dominos_desktop.webp"),
        height: 811,
        width: 1440
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(_components_screens_funnels_custody_whitepaper__WEBPACK_IMPORTED_MODULE_3__/* .Screen */ .l, _objectSpread({}, props))]
  });
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (Page);

/***/ }),

/***/ 1153:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/f/custody-whitepaper/l",
      function () {
        return __webpack_require__(6903);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [309,945,250,804,456,382,774,888,179], function() { return __webpack_exec__(1153); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);